import type { RequestPayload } from "@inertiajs/core";
import { router } from "@inertiajs/react";
import { ProbationConfigForm } from "../../../components/reportConfig/form/ProbationConfigForm";
import { useYearContext } from "../../../hooks/useYearContext";
import { ContentShell } from "../../../layout/ContentShell";
import type { Group } from "../../../models/group";
import type { ProbationConfiguration } from "../../../models/reportConfigs/probationConfiguration";
import type { YearContext } from "../../../models/yearContext";
import { report_configurations_path } from "../../../routes";

type ProbationConfigDuplicateProps = {
  probation_config: ProbationConfiguration;
  year_contexts: YearContext[];
  groups: Group[];
};

export default function ProbationConfigDuplicate({ year_contexts, groups, probation_config }: ProbationConfigDuplicateProps) {
  const { pathWithYearContext } = useYearContext();
  const onSubmit = (values: RequestPayload) => router.post(pathWithYearContext(report_configurations_path), values);

  return (
    <ContentShell
      title={`Zertifikat-Vorlage ${probation_config.title}`}
      onBack={() => router.get(pathWithYearContext(report_configurations_path))}
    >
      <ProbationConfigForm
        probationConfig={probation_config}
        yearContexts={year_contexts}
        groups={groups}
        saveButtonLabel="Erstellen"
        onSubmit={onSubmit}
      />
    </ContentShell>
  );
}
